<template>
  <div id="login" class="centered-form">
    <AppHeader />
    <div class="card container">
      <h1>{{ $t('auth.login_title') }}</h1>
      <div v-if="errorMessage" class="alert alert-danger fade show" role="alert">
        {{ errorMessage }}
      </div>
      <form @submit.prevent>
        <div class="form-group">
          <label for="email1">{{ $t('auth.email_label') }}</label>
          <input
            class="form-control"
            v-model.trim="loginForm.email"
            type="email"
            :placeholder="$t('auth.email_place_holder')"
            id="email1"
          />
        </div>

        <div class="form-group">
          <label for="password1">{{ $t('auth.password_label') }}</label>
          <input
            class="form-control"
            v-model.trim="loginForm.password"
            type="password"
            :placeholder="$t('auth.password_place_holder')"
            id="password1"
          />
        </div>
      </form>

      <div class="extras">
        <div>
          <button @click="login" class="btn btn-primary">
            {{ $t('auth.log_in_button') }}
          </button>
        </div>
        <div>
          <router-link to="/reset">{{ $t('auth.forgot_password_button') }}</router-link>
          <!-- <a>{{ $t("auth.create_account_button") }}</a> -->
          <button
            class="btn btn-outline-primary btn-sm dropdown-toggle"
            type="button"
            id="locale"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {{ locale | fullLocale }}
          </button>
          <ul class="dropdown-menu" aria-labelledby="locale">
            <li><a class="dropdown-item" href="#" v-on:click="setLocale('en')">{{ 'en' | fullLocale}}</a></li>
            <li><a class="dropdown-item" href="#" v-on:click="setLocale('fr')">{{ 'fr' | fullLocale}}</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/ui/AppHeader.vue';
import AuthenticationService from '@/service/AuthenticationService';
import I18nMixin from '@/utils/I18nMixin';

export default {
  mixins: [I18nMixin],
  components: {
    AppHeader,
  },
  data() {
    return {
      loginForm: {
        email: '',
        password: '',
      },
      errorMessage: null,
      redirectUrl: null,
    };
  },
  methods: {
    login() {
      // FIXME: do the opposite (i.e dispatch only)
      const authenticationService = new AuthenticationService(this.$store);
      authenticationService
        .login(this.loginForm.email, this.loginForm.password)
        .then(() => {
          if (this.redirectUrl) {
            this.$router.push(this.redirectUrl);
          } else {
            this.$router.push('/admin/overview');
          }
        })
        .catch((error) => {
          switch (error.code) {
            case 'auth/wrong-password':
              this.errorMessage = this.$t('auth.errors.wrong_password');
              break;
            case 'auth/user-not-found':
              this.errorMessage = this.$t('auth.errors.user_not_found');
              break;
            case 'auth/invalid-email':
              this.errorMessage = this.$t('auth.errors.invalid_email');
              break;
            default:
              this.errorMessage = this.$t('auth.errors.unknown_error');
              console.log(error);
              break;
          }
        });
    },
  },
  mounted() {
    this.redirectUrl = this.$route.query.redirectUrl;
  },
};
</script>

<style scoped>
#locale {
  margin-top: 20px;
  font-size: .8rem;
}
</style>
